import type { ApexOptions } from 'apexcharts'
import type { ChurnData } from '../../../features/revenue/domain/models/churn'
import { DataType } from '../../../features/revenue/domain/models/mrr'
import {
  buildBarChartOptions,
  ChartColors,
  monthYearFormatter,
  createYAxisFormatter,
  createTooltipValueFormatter,
  type ChartSeriesItem
} from '../charts'

export const getChurnChartOptions = (
  data: ChurnData[],
  dataType: DataType,
  formatCategory: (dateStr: string) => string = monthYearFormatter
): ApexOptions => {
  const isEconomics = dataType === DataType.Economics

  const categories = data.map((d) => d.date)

  const series: ChartSeriesItem[] = [
    {
      name: isEconomics ? 'MRR Churn' : 'User Churn',
      data: data.map((d) => d.totalChurn),
      color: ChartColors.red
    }
  ]

  return buildBarChartOptions({
    series,
    categories,
    yAxisFormatter: createYAxisFormatter(isEconomics),
    tooltipValueFormatter: createTooltipValueFormatter(isEconomics),
    xAxisLabelFormatter: formatCategory
  })
}
